import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface RejectInlineProps {
  reason: string;
  onReasonChange: (v: string) => void;
  onSubmit: () => void;
  submitting: boolean;
  placeholder: string;
}

export function RejectInline({
  reason,
  onReasonChange,
  onSubmit,
  submitting,
  placeholder,
}: RejectInlineProps) {
  return (
    <div className="mt-3.5 rounded-[14px] border border-bad bg-bad-soft px-5 py-[18px]">
      <Label htmlFor="reject-reason" className="text-[12.5px] font-bold text-bad">
        Motivo da rejeição
      </Label>
      <Textarea
        id="reject-reason"
        value={reason}
        onChange={(e) => onReasonChange(e.target.value)}
        rows={3}
        placeholder={placeholder}
        className="mt-[9px] min-h-[74px] rounded-[11px] border-border bg-card text-[13.5px] leading-relaxed"
      />
      <Button
        className="mt-3 h-[42px] rounded-[11px] bg-bad px-[18px] text-[13px] font-bold text-bad-foreground hover:bg-bad/90"
        onClick={onSubmit}
        disabled={submitting}
      >
        {submitting && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
        Enviar rejeição
      </Button>
    </div>
  );
}
